import moment from "moment";
import 'moment/locale/de';
import _ from "lodash";

const format_date = (i) => {
    moment.locale('de');
    return moment(i).format('L')
}

const getMonth = (i) => {
    moment.locale('de');
    return moment(i).format('MMMM YYYY')
}

const dynamicStringSort = (property) => {
    let sortOrder = 1;
    if (property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }

    function clean(s) {
        return _.trim(s).toLowerCase()
    }

    return function (a, b) {
        const result = (clean(a[property]) < clean(b[property])) ? -1 : (clean(a[property]) > clean(b[property])) ? 1 : 0;
        return result * sortOrder;
    }
}

export {format_date, getMonth, dynamicStringSort}